(function () {
  'use strict';

  var q = function (selector, context) { return (context || document).querySelector(selector); };
  var qa = function (selector, context) { return Array.prototype.slice.call((context || document).querySelectorAll(selector)); };

  // Ruleaza o initializare izolat. Daca una crapa, restul merg mai departe.
  function safe(name, fn) {
    try {
      fn();
    } catch (error) {
      if (window.console && console.error) console.error('[biome] init esuat: ' + name, error);
    }
  }

  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'RON';
    try {
      return new Intl.NumberFormat('ro-RO', { style: 'currency', currency: currency }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',') + ' lei';
    }
  }

  function initHero(root) {
    var slides = qa('[data-br-slide]', root);
    var dots = qa('[data-br-dot], [data-br-hero-go]', root);
    if (!slides.length) return;
    var active = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }));
    var timer;
    var autoplay = root.getAttribute('data-autoplay') !== 'false';
    var delay = autoplay ? (Number(root.getAttribute('data-interval')) || Number(root.getAttribute('data-autoplay')) || 7000) : 0;

    function show(index) {
      active = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === active);
        slide.setAttribute('aria-hidden', i === active ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === active);
        dot.setAttribute('aria-current', i === active ? 'true' : 'false');
        dot.setAttribute('aria-selected', i === active ? 'true' : 'false');
      });
    }

    function restart() {
      if (!delay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      window.clearInterval(timer);
      timer = window.setInterval(function () { show(active + 1); }, delay);
    }

    qa('[data-br-prev], [data-br-hero-prev]', root).forEach(function (button) { button.addEventListener('click', function () { show(active - 1); restart(); }); });
    qa('[data-br-next], [data-br-hero-next]', root).forEach(function (button) { button.addEventListener('click', function () { show(active + 1); restart(); }); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i); restart(); }); });

    var touchStart = null;
    root.addEventListener('touchstart', function (event) { touchStart = event.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (event) {
      if (touchStart === null) return;
      var delta = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(delta) > 45) show(active + (delta < 0 ? 1 : -1));
      touchStart = null;
      restart();
    }, { passive: true });

    root.addEventListener('mouseenter', function () { window.clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    show(active);
    restart();
  }

  function initQuiz(root) {
    var panels = qa('[data-br-quiz-step], [data-br-quiz-panel]', root);
    if (!panels.length) return;
    var resultsHolder = q('[data-br-quiz-results]', root);
    var stepPills = qa('[data-br-quiz-progress], [data-br-step-pill]', root);
    var answers = {};
    var step = 0;

    // Retinem lista initiala de variante pentru fiecare rezultat, ca sa o
    // putem reface cand utilizatorul reia quiz-ul sau alege alta nevoie.
    qa('[data-br-add-all]', root).forEach(function (add) {
      if (!add.hasAttribute('data-variant-ids-initial')) {
        add.setAttribute('data-variant-ids-initial', add.getAttribute('data-variant-ids') || '');
      }
    });

    function visibleCards(result) {
      return qa('[data-br-quiz-product]', result).filter(function (card) { return !card.hidden; });
    }

    function syncAddButton(result) {
      var ids = visibleCards(result).map(function (card) { return card.getAttribute('data-variant-id'); }).filter(Boolean);
      var add = q('[data-br-add-all]', result);
      if (add) {
        add.setAttribute('data-variant-ids', ids.join(','));
        add.disabled = !ids.length;
      }
      var empty = q('[data-br-quiz-empty]', result);
      if (empty) {
        empty.hidden = ids.length > 0;
        empty.style.display = ids.length > 0 ? 'none' : '';
      }
    }

    // Cardurile scoase cu X sunt doar ascunse, nu sterse din DOM. Varianta
    // veche folosea card.remove(), deci produsul nu mai reaparea niciodata:
    // nici dupa "Alege altceva", nici la reselectarea aceleiasi nevoi.
    function resetResults() {
      qa('[data-br-quiz-result]', root).forEach(function (result) {
        qa('[data-br-quiz-product]', result).forEach(function (card) {
          card.hidden = false;
          card.style.display = '';
        });
        var add = q('[data-br-add-all]', result);
        if (add) {
          var initial = add.getAttribute('data-variant-ids-initial') || '';
          add.setAttribute('data-variant-ids', initial);
          add.disabled = !initial;
        }
        var empty = q('[data-br-quiz-empty]', result);
        if (empty) { empty.hidden = true; empty.style.display = 'none'; }
      });
    }

    function render() {
      panels.forEach(function (panel, index) { panel.hidden = index !== step; });
      stepPills.forEach(function (pill, index) { pill.classList.toggle('is-active', index <= step); });
      if (resultsHolder) resultsHolder.hidden = true;
    }

    function showResult() {
      // Fiecare raspuns porneste de la rutina completa.
      resetResults();
      var results = qa('[data-br-result], [data-br-quiz-result]', root);
      var selected = results.find(function (result) {
        return result.getAttribute('data-goal') === answers.goal;
      }) || results[0];
      results.forEach(function (result) {
        var isSelected = result === selected;
        result.classList.toggle('is-active', isSelected);
        result.hidden = !isSelected;
      });
      panels.forEach(function (panel) { panel.hidden = true; });
      if (resultsHolder) {
        resultsHolder.hidden = false;
        // Pe mobil rezultatul apare sub fold. Il aducem in ecran.
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          try {
            resultsHolder.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } catch (error) {
            resultsHolder.scrollIntoView();
          }
        }
      }
    }

    qa('[data-br-answer], [data-br-quiz-answer]', root).forEach(function (button) {
      button.addEventListener('click', function () {
        var key = button.getAttribute('data-key') || button.getAttribute('data-br-quiz-field');
        var value = button.getAttribute('data-value') || button.getAttribute('data-br-quiz-value');
        answers[key] = value;
        qa('[data-br-quiz-field="' + key + '"], [data-key="' + key + '"]', root).forEach(function (item) {
          var selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        var panel = button.closest('[data-br-quiz-step], [data-br-quiz-panel]');
        if (panel) qa('[data-br-quiz-next], [data-br-quiz-finish]', panel).forEach(function (control) { control.disabled = false; });

        // Quiz intr-un singur pas. Obiectivul e singurul raspuns care schimba
        // rezultatul, deci nu mai cerem inca doua click-uri degeaba.
        if (key === 'goal') {
          window.setTimeout(showResult, 170);
        }
      });
    });
    qa('[data-br-quiz-next]', root).forEach(function (button) { button.addEventListener('click', function () { step = Math.min(panels.length - 1, step + 1); render(); }); });
    qa('[data-br-quiz-back]', root).forEach(function (button) { button.addEventListener('click', function () { step = Math.max(0, step - 1); render(); }); });
    qa('[data-br-quiz-finish]', root).forEach(function (button) { button.addEventListener('click', showResult); });
    qa('[data-br-quiz-restart]', root).forEach(function (button) {
      button.addEventListener('click', function () {
        answers = {};
        step = 0;
        qa('[data-br-quiz-answer]', root).forEach(function (answer) { answer.classList.remove('is-selected'); answer.setAttribute('aria-pressed', 'false'); });
        qa('[data-br-quiz-next], [data-br-quiz-finish]', root).forEach(function (control) { control.disabled = true; });
        resetResults();
        render();
      });
    });
    qa('[data-br-quiz-remove]', root).forEach(function (button) {
      button.addEventListener('click', function () {
        var card = button.closest('[data-br-quiz-product]');
        var result = button.closest('[data-br-quiz-result]');
        // display inline, fiindca .br-quiz-product are display din CSS si ar
        // castiga in fata atributului hidden.
        if (card) { card.hidden = true; card.style.display = 'none'; }
        if (result) syncAddButton(result);
      });
    });
    render();
  }

  function addItems(items, button) {
    if (!items.length) return Promise.resolve();
    var originalButtonHTML = button && button.innerHTML;
    var originalButtonLabel = button && button.getAttribute('aria-label');
    if (button) { button.disabled = true; button.classList.add('is-loading'); }
    return fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart add failed');
      return response.json();
    }).then(function (cartItem) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: cartItem } }));
      return cartItem;
    }).catch(function () {
      if (button) {
        var compactButton = button.textContent.trim() === '+';
        button.textContent = compactButton ? '!' : 'Încearcă din nou';
        button.setAttribute('aria-label', 'Produsul nu a putut fi adăugat. Încearcă din nou.');
        window.setTimeout(function () {
          button.innerHTML = originalButtonHTML;
          if (originalButtonLabel === null) button.removeAttribute('aria-label');
          else button.setAttribute('aria-label', originalButtonLabel);
        }, 2200);
      }
    }).finally(function () {
      if (button) { button.disabled = false; button.classList.remove('is-loading'); }
    });
  }

  function initMultiAdd() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-br-add-items], [data-br-add-all]');
      if (!button) return;
      event.preventDefault();
      var raw = button.getAttribute('data-variant-ids') || '';
      var ids = raw.split(',').map(function (id) { return Number(id.trim()); }).filter(Boolean);
      addItems(ids.map(function (id) { return { id: id, quantity: 1 }; }), button);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('.br-product-card__form, .br-switch-card__form, .br-cart-upsell__form');
      if (!form) return;
      var idInput = q('[name="id"]', form);
      var quantityInput = q('[name="quantity"]', form);
      var button = q('[type="submit"]', form);
      var id = Number(idInput && idInput.value);
      if (!id) return;
      event.preventDefault();
      addItems([{ id: id, quantity: Number(quantityInput && quantityInput.value) || 1 }], button);
    });
  }

  function readProductContext() {
    var context = q('#BiomeProductContext');
    if (!context) return null;
    try { return JSON.parse(context.textContent); } catch (error) { return null; }
  }

  function renderDailyPrice(price, days) {
    if (!days || !price) return;
    qa('[data-product-price]').forEach(function (priceElement) {
      var holder = priceElement.closest('.product-block') || priceElement.parentNode;
      if (!holder) return;
      var daily = q('[data-br-product-daily]', holder);
      if (!daily) {
        daily = document.createElement('div');
        daily.className = 'br-daily-price';
        daily.setAttribute('data-br-product-daily', '');
        holder.appendChild(daily);
      }
      daily.textContent = money(Math.round(price / days)) + ' / zi pentru ' + days + ' zile';
    });
  }

  function initProductPrice() {
    var context = readProductContext();
    if (!context) return;

    if (context.daysSupply) {
      var variantJSON = q('[data-variant-json]');
      if (variantJSON) {
        try {
          var variants = JSON.parse(variantJSON.value || variantJSON.textContent);
          if (variants && variants[0]) renderDailyPrice(variants[0].price, context.daysSupply);
        } catch (error) {}
      }
      document.addEventListener('variant:change', function (event) {
        if (event.detail && event.detail.variant) renderDailyPrice(event.detail.variant.price, context.daysSupply);
      });
    }

    var meta = q('.product-single__meta');
    if (meta && !q('.br-product-trust', meta)) {
      var trust = document.createElement('div');
      trust.className = 'br-product-trust';
      trust.innerHTML = '<span>Brand românesc</span><span>Costul pus în context</span><span>Livrare 1–3 zile</span>';
      var form = q('.product-single__form', meta);
      // form nu e copil direct al lui meta, deci inseram in parintele lui real.
      // Varianta veche (meta.insertBefore) arunca NotFoundError si oprea tot restul scriptului.
      if (form && form.parentNode) {
        form.parentNode.insertBefore(trust, form);
      } else {
        meta.appendChild(trust);
      }
    }
  }

  // Costul pe zi foloseste days_supply REAL, citit din harta handle -> zile
  // injectata ca JSON in cart-drawer (data-br-days-supply), generata din
  // metafield-urile custom.days_supply. NU mai presupunem 30 de zile.
  // Produsele care nu apar in harta (pulberi, sirop, protocoale, orice fara
  // days_supply real) NU intra in costul pe zi, exact ca pe pagina de produs.
  var _biomeDaysMap = null;
  function daysMap() {
    if (_biomeDaysMap) return _biomeDaysMap;
    _biomeDaysMap = {};
    var holder = q('[data-br-days-supply]');
    if (holder) {
      try { _biomeDaysMap = JSON.parse(holder.textContent) || {}; } catch (error) { _biomeDaysMap = {}; }
    }
    return _biomeDaysMap;
  }

  function daysForItem(item) {
    if (!item) return 0;
    var days = daysMap()[item.handle];
    return days > 0 ? days : 0;
  }

  function updateCartLayer() {
    var drawer = q('#CartDrawerForm');
    if (!drawer) return;
    fetch((window.theme && theme.routes && theme.routes.cart) || '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var progress = q('[data-br-cart-progress]', drawer);
        var threshold = Number(progress && progress.getAttribute('data-threshold')) || 15000;
        if (progress) {
          var percent = Math.min(100, (cart.total_price / threshold) * 100);
          var bar = q('i', progress);
          var copy = q('[data-br-cart-progress-copy]', progress);
          if (bar) bar.style.width = percent + '%';
          if (copy) copy.textContent = cart.total_price >= threshold ? 'Ai livrare gratuită.' : 'Mai ai ' + money(threshold - cart.total_price) + ' până la livrare gratuită.';
        }
        var seen = {};
        var daily = cart.items.reduce(function (sum, item) {
          if (seen[item.product_id]) return sum;
          seen[item.product_id] = true;
          var days = daysForItem(item);
          return days ? sum + Math.round(item.final_price / days) : sum;
        }, 0);
        var dailyNode = q('[data-br-cart-daily]', drawer);
        if (dailyNode) {
          dailyNode.hidden = daily <= 0;
          var value = q('strong', dailyNode);
          if (value) value.textContent = money(daily) + ' / zi';
        }

        // Blocul vechi de upsell (handle-uri hardcodate, [data-br-upsell-product-id])
        // a fost scos din drawer. Recomandarile vin acum din updateUpsell(), care
        // stie ce e in cos. Nu pune la loc filtrarea de aici: ascundea .br-cart-upsell
        // cand nu gasea vechile noduri, deci ar ascunde exact recomandarea noua.
      }).catch(function () {});
  }

  // Recomandarea din cos. Continutul e calculat in Liquid (templates/cart.upsell.liquid),
  // ca sa avem acces la metafield-urile de ingrediente si sa nu duplicam preturi in JS.
  function updateUpsell() {
    var slots = qa('[data-br-upsell-slot]');
    if (!slots.length) return;
    fetch('/cart?view=upsell', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var payload = q('[data-br-upsell-payload]', holder);
        if (!payload) return;
        slots.forEach(function (slot) {
          slot.innerHTML = payload.innerHTML;
          slot.hidden = !payload.innerHTML.trim();
        });
      }).catch(function () {});
  }

  function initCartLayer() {
    ['ajaxProduct:added', 'cart:updated', 'cart:build'].forEach(function (name) {
      document.addEventListener(name, function () {
        window.setTimeout(updateCartLayer, 180);
        window.setTimeout(updateUpsell, 200);
      });
    });
    updateCartLayer();
    updateUpsell();
  }

  function initDetails() {
    qa('.br-faq-list details, .br-faq__list details, .br-product-faq__list details').forEach(function (detail) {
      detail.addEventListener('toggle', function () {
        if (!detail.open) return;
        var group = detail.closest('.br-faq-list, .br-faq__list, .br-product-faq__list');
        if (!group) return;
        qa('details', group).forEach(function (other) { if (other !== detail) other.open = false; });
      });
    });
  }

  function initCartDrawerA11y() {
    var drawer = q('#CartDrawer');
    if (!drawer) return;

    function syncState() {
      drawer.setAttribute('aria-hidden', drawer.classList.contains('drawer--is-open') ? 'false' : 'true');
    }

    syncState();
    if ('MutationObserver' in window) {
      new MutationObserver(syncState).observe(drawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  function initMobileStickyAtc() {
    qa('[data-br-mobile-atc]').forEach(function (sticky) {
      if (sticky.getAttribute('data-br-initialized') === 'true') return;
      sticky.setAttribute('data-br-initialized', 'true');

      var sectionId = sticky.getAttribute('data-product-section-id');
      var productSection = sectionId ? document.getElementById('ProductSection-' + sectionId) : null;
      var primaryButton = productSection && q('[data-add-to-cart]', productSection);
      var primaryLabel = primaryButton && q('[data-add-to-cart-text]', primaryButton);
      var stickyButton = q('[data-br-mobile-atc-button]', sticky);
      var stickyLabel = q('[data-br-mobile-atc-label]', sticky);
      var mobileQuery = window.matchMedia('(max-width: 749px)');
      var hasPassedPrimary = false;
      var currentPrice = Number(sticky.getAttribute('data-price')) || 0;

      if (!primaryButton || !stickyButton || !stickyLabel) return;

      function syncButton(variant) {
        var available = variant ? Boolean(variant.available) : !primaryButton.disabled;
        if (variant && variant.price != null) currentPrice = Number(variant.price) || 0;
        var sourceLabel = primaryLabel && primaryLabel.textContent.trim();
        stickyButton.disabled = !available;
        stickyLabel.textContent = available
          ? (sourceLabel || 'Adaugă în coș') + ' · ' + money(currentPrice)
          : (sourceLabel || 'Indisponibil');
      }

      function updateVisibility() {
        var drawerOpen = document.documentElement.classList.contains('js-drawer-open')
          || document.documentElement.classList.contains('js-drawer-closing');
        var visible = mobileQuery.matches && hasPassedPrimary && !drawerOpen;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        stickyButton.setAttribute('tabindex', visible ? '0' : '-1');
      }

      stickyButton.addEventListener('click', function () {
        if (!primaryButton.disabled) primaryButton.click();
      });

      productSection.addEventListener('variantChange', function (event) {
        window.setTimeout(function () {
          syncButton(event.detail && event.detail.variant);
        }, 0);
      });

      if ('MutationObserver' in window) {
        new MutationObserver(function () { syncButton(); }).observe(primaryButton, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          characterData: true,
          subtree: true
        });
        new MutationObserver(updateVisibility).observe(document.documentElement, {
          attributes: true,
          attributeFilter: ['class']
        });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var entry = entries[0];
          hasPassedPrimary = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          updateVisibility();
        }, { threshold: 0 }).observe(primaryButton);
      } else {
        window.addEventListener('scroll', function () {
          hasPassedPrimary = primaryButton.getBoundingClientRect().bottom < 0;
          updateVisibility();
        }, { passive: true });
      }

      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', updateVisibility);
      else mobileQuery.addListener(updateVisibility);

      syncButton();
      updateVisibility();
    });
  }

  function init() {
    safe('hero', function () { qa('[data-br-hero]').forEach(initHero); });
    safe('quiz', function () { qa('[data-br-quiz]').forEach(initQuiz); });
    safe('multiAdd', initMultiAdd);
    safe('productPrice', initProductPrice);
    safe('cartLayer', initCartLayer);
    safe('details', initDetails);
    safe('cartDrawerA11y', initCartDrawerA11y);
    safe('mobileStickyAtc', initMobileStickyAtc);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (event) {
    safe('hero:reload', function () { qa('[data-br-hero]', event.target).forEach(initHero); });
    safe('quiz:reload', function () { qa('[data-br-quiz]', event.target).forEach(initQuiz); });
    safe('mobileStickyAtc:reload', initMobileStickyAtc);
  });
})();
